import axios from "axios";
const baseUrl = "/api/v1";

// This file specifically will be for seconopinion page
export const secondopinion = {
  post: (payload) => axios.post(`${baseUrl}/secondopinions`, payload), // create seconopinion
  put: (payload, id) => axios.put(`${baseUrl}/secondopinions/${id}`, payload), // update seconopinion
  delete: (payload, id) => axios.delete(`${baseUrl}/secondopinions/${id}`), // delete seconopinion
};
